import BS from 'components/Search/BinSearch'

import createWrappedField from './createWrappedField'

export default createWrappedField({
  Component: BS,
  name: 'DDIBinSearch'
})
